/**
 * Page standalone du module SADAStock pour les agents (rôle agent / supervisor)
 * qui n'ont pas accès à AdminPage. Affiche uniquement l'InventoryTab avec un
 * header simple et un bouton retour.
 */
import React, { useState } from 'react';
import { ArrowLeft, Package, Lock } from 'lucide-react';
import { Button } from '../components/ui/button';
import InventoryTab from '../components/admin/InventoryTournant/InventoryTab';
import ChangePasswordDialog from '../components/ChangePasswordDialog';

const SadaStockStandalonePage = ({ onBack }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#5B3B8C] to-[#7C4FB8] shadow-md">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center gap-3">
          <Button
            variant="ghost"
            onClick={onBack}
            className="text-white hover:bg-white/10 -ml-2"
            data-testid="sadastock-back-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-1" />
            Retour
          </Button>
          <div className="flex items-center gap-2 text-white flex-1">
            <Package className="w-6 h-6" />
            <div>
              <h1 className="text-lg font-semibold leading-tight">SADAStock</h1>
              <p className="text-xs text-white/80">Inventaire tournant avancé</p>
            </div>
          </div>
          <Button
            variant="ghost"
            onClick={() => setShowPassword(true)}
            className="text-white hover:bg-white/10"
            data-testid="sadastock-change-password-btn"
            title="Changer mon mot de passe"
          >
            <Lock className="w-4 h-4 mr-1.5" />
            <span className="hidden sm:inline">Mot de passe</span>
          </Button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-4 pb-24">
        <InventoryTab />
      </div>

      {showPassword && (
        <ChangePasswordDialog onClose={() => setShowPassword(false)} />
      )}
    </div>
  );
};

export default SadaStockStandalonePage;
